import { css } from "styled-components";

/**
 * Below styles overwrites default MUI X DatePicker component styles (Calendar pop up only).
 * If this file is removed from the bundle, the MUI X DatePicker will continue rendering default Material UI styles.
 */
const muiDatePickerCssOverwrite = css`
    .MuiPaper-root {
        margin: 24px 0;
    }

    .MuiCalendarPicker-root {
        border-radius: 2px;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.25);
        border: 1px solid #fff;
        background-color: #2a2a2a;
        color: white;
    }

    .MuiCalendarPicker-root .MuiIconButton-root {
        color: white;
    }

    .MuiCalendarPicker-root .MuiPickersArrowSwitcher-root .MuiPickersArrowSwitcher-button {
        color: #bfbfbf;
    }

    .MuiCalendarPicker-root .MuiTypography-caption {
        color: rgba(255, 255, 255, 0.5);
    }

    .MuiCalendarPicker-root .Mui-disabled {
        color: rgba(255, 255, 255, 0.25) !important;
    }

    .MuiCalendarPicker-root .MuiPickersDay-root {
        background-color: transparent;
        color: white;
    }

    .MuiCalendarPicker-root .MuiPickersDay-root:hover {
        background-color: #8099ff;
    }

    .MuiCalendarPicker-root .MuiPickersDay-root .Mui-selected {
        background-color: #4065fc !important;
    }

    .MuiCalendarPicker-root .PrivatePickersYear-root .Mui-selected {
        background-color: #4065fc;
    }

    .MuiCalendarPicker-root .MuiPickersDay-root:not(.Mui-selected) {
        border: 1px solid transparent;
    }
`;

export default muiDatePickerCssOverwrite;
